module.exports = __webpack_public_path__ + "static/media/1.29e053d6.jpg";